var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full transition-all duration-300" },
    [
      _vm.period.is_booked === false
        ? _c(
            "div",
            {
              staticClass:
                "w-full border rounded px-1.5 flex flex-col justify-center gap-1 transition-all duration-300 cursor-pointer",
              class: {
                "pt-4": _vm.isFirst,
                "pointer-events-none": !_vm.currentUser.role.includes("admin"),
                "hover:bg-hover-state": !_vm.isSelected
              },
              style: {
                backgroundColor: _vm.period.element.backgroundColor,
                borderColor: _vm.period.element.borderColor,
                height: _vm.period.element.height
              },
              attrs: { title: "Make appointment" },
              on: { click: _vm.onMakeAppointment }
            },
            [
              _c("BlTextBody2", {
                staticClass: "transition-all duration-300",
                style: { color: _vm.period.element.color },
                attrs: {
                  text:
                    _vm.period.start_time_string +
                    " - " +
                    _vm.period.end_time_string
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.period.is_booked
        ? _c(
            "div",
            {
              staticClass:
                "relative border rounded px-1.5 transition-all duration-300",
              class: {
                "pt-4": _vm.isFirst,
                "border-dashed": _vm.period.appointment.status.includes(
                  "booking"
                )
              },
              style: {
                backgroundColor: _vm.period.element.backgroundColor,
                borderColor: _vm.period.element.borderColor,
                height: _vm.period.element.height
              },
              on: { click: _vm.openAppointmentDetails }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex h-full cursor-pointer",
                  class: {
                    "items-center justify-between gap-1":
                      _vm.isCompact && _vm.period.count === 1,
                    "flex-col justify-center gap-0.5":
                      !_vm.isCompact || _vm.period.count > 1
                  }
                },
                [
                  _vm.isEmptyTherapist && !_vm.isCompact
                    ? _c("BlIcon", {
                        staticClass: "w-6 h-6",
                        attrs: { icon: "warning", color: "tomato-7" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEmptyTherapist &&
                  _vm.isOpenRoom &&
                  (!_vm.isCompact || _vm.period.count > 1)
                    ? _c("BlTextBody2", {
                        staticClass: "truncate",
                        style: { color: _vm.period.element.color },
                        attrs: { text: _vm.period.appointment.user.name }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-between gap-1 truncate",
                      class: { "w-full": _vm.isEmptyTherapist && _vm.isCompact }
                    },
                    [
                      _vm.period.appointment.client &&
                      _vm.period.appointment.client.name
                        ? _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            style: { color: _vm.period.element.color },
                            attrs: { text: _vm.period.appointment.client.name }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEmptyTherapist && _vm.isCompact
                        ? _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: { icon: "warning", color: "tomato-7" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isEmptyTherapist &&
                  (!_vm.isCompact || _vm.period.count > 1)
                    ? _c("BlTextBody2", {
                        style: { color: _vm.period.element.color },
                        attrs: { text: "Please review" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEmptyTherapist &&
                  _vm.isCompact &&
                  _vm.period.count === 1
                    ? _c("BlTextBody2", {
                        style: { color: _vm.period.element.color },
                        attrs: {
                          text: _vm.period.appointment.start_time_string
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEmptyTherapist &&
                  (!_vm.isCompact || _vm.period.count > 1)
                    ? _c("BlTextBody2", {
                        style: { color: _vm.period.element.color },
                        attrs: {
                          text:
                            _vm.period.appointment.start_time_string +
                            " - " +
                            _vm.period.appointment.end_time_string
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEmptyTherapist &&
                  !_vm.isCompact &&
                  _vm.enableBranch &&
                  _vm.period.appointment.room.branch
                    ? _c("BlTextBody2", {
                        staticClass: "truncate",
                        style: { color: _vm.period.element.color },
                        attrs: { text: _vm.period.appointment.room.branch.name }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.detailsOpened &&
              _vm.period.appointment &&
              _vm.period.appointment.status.includes("booking")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute top-0 flex flex-col flex-shrink-0 w-64 gap-1 mx-2 overflow-y-auto border rounded shadow-md bg-pure-white border-grey-200",
                      class: [
                        _vm.period.is_last_column ? "right-full" : "left-full"
                      ],
                      style: { zIndex: 2 },
                      attrs: { "data-id": _vm.dataId }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between flex-shrink-0 w-full h-8 px-3 bg-slate-300",
                          attrs: { "data-id": _vm.dataId }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to:
                                  "/appointments/details/" +
                                  _vm.period.appointment.id
                              }
                            },
                            [
                              _c("BlTextBody3", {
                                staticClass: "capitalize",
                                attrs: {
                                  "data-id": _vm.dataId,
                                  text: _vm.period.appointment.status.replaceAll(
                                    "_",
                                    " "
                                  )
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "w-4 h-4",
                            attrs: {
                              icon: "close",
                              color: "slate-6",
                              clickable: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.appointmentLoading
                        ? _c(
                            "div",
                            {
                              staticClass: "grid h-28 place-items-center",
                              attrs: { "data-id": _vm.dataId }
                            },
                            [
                              _c("div", {
                                staticClass: "blum-loader-sm",
                                attrs: { "data-id": _vm.dataId }
                              })
                            ]
                          )
                        : !_vm.appointmentDetails
                        ? _c(
                            "div",
                            {
                              staticClass: "grid h-28 place-items-center",
                              attrs: { "data-id": _vm.dataId }
                            },
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  "data-id": _vm.dataId,
                                  text: "Appointment not found"
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col flex-shrink-0 gap-3 p-3",
                              attrs: { "data-id": _vm.dataId }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-col gap-1",
                                  attrs: { "data-id": _vm.dataId }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    attrs: {
                                      "data-id": _vm.dataId,
                                      text: "Appointment in progress"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { attrs: { "data-id": _vm.dataId } },
                                    [
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          text:
                                            "This appointment slot is currently being booked by "
                                        }
                                      }),
                                      _vm._v(" "),
                                      !_vm.appointmentDetails.user
                                        ? _c("BlTextSubtitle3", {
                                            staticClass: "italic",
                                            attrs: {
                                              "data-id": _vm.dataId,
                                              text: "Deleted user"
                                            }
                                          })
                                        : _c("BlTextSubtitle3", {
                                            attrs: {
                                              "data-id": _vm.dataId,
                                              text:
                                                _vm.appointmentDetails.user.name
                                            }
                                          }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          text: "and will be reserved until "
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextSubtitle3", {
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          text: _vm.displayDate(
                                            _vm.appointmentDetails.end_time,
                                            "HH:mm"
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _vm.currentUser.role.includes("admin") &&
                      _vm.appointmentDetails &&
                      _vm.appointmentDetails.user_id === _vm.currentUser.id
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center flex-shrink-0 w-full h-12 px-3 border-t border-slate-400 gap-14",
                              attrs: { "data-id": _vm.dataId }
                            },
                            [
                              _vm.appointmentDetails.status === "in_progress"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex justify-center flex-grow py-1 truncate rounded cursor-pointer hover:bg-hover-state",
                                      attrs: {
                                        "data-id": _vm.dataId,
                                        title: "Resume booking appointment"
                                      },
                                      on: { click: _vm.onResumeMakeAppointment }
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          text: "Resume booking appointment"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.appointmentDetails.status === "completed"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex justify-center flex-grow py-1 truncate rounded",
                                      attrs: { "data-id": _vm.dataId }
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        attrs: {
                                          "data-id": _vm.dataId,
                                          text:
                                            "Please wait, appointment is scheduling..."
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.period.appointment &&
      !_vm.period.appointment.status.includes("booking")
        ? _c(
            "div",
            {
              staticClass:
                "fixed flex-shrink-0 overflow-y-auto transition-all duration-300 border shadow-md outline-none bg-pure-white border-grey-200",
              style: {
                zIndex: 101,
                top: "7.5rem",
                right: _vm.detailsOpened ? "0rem" : " -28.75rem",
                height: "calc(100vh - 7.5rem)",
                width: "28.75rem"
              },
              attrs: { "data-id": _vm.dataId }
            },
            [
              _vm.appointmentLoading
                ? _c(
                    "div",
                    {
                      staticClass: "grid h-full place-items-center",
                      attrs: { "data-id": _vm.dataId }
                    },
                    [
                      _c("div", {
                        staticClass: "blum-loader",
                        attrs: { "data-id": _vm.dataId }
                      })
                    ]
                  )
                : !_vm.appointmentDetails
                ? _c(
                    "div",
                    {
                      staticClass: "grid h-full place-items-center",
                      attrs: { "data-id": _vm.dataId }
                    },
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          "data-id": _vm.dataId,
                          text: "Appointment not found"
                        }
                      })
                    ],
                    1
                  )
                : _c("UpcomingAppointments", {
                    attrs: {
                      "data-id": _vm.dataId,
                      id: _vm.dataId,
                      appointment: _vm.appointmentDetails
                    },
                    on: {
                      "after-commit": function($event) {
                        return _vm.$emit("after-commit")
                      }
                    }
                  })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.rescheduleOpened && _vm.currentUser.role.includes("admin")
        ? _c("RescheduleAppointmentOverlay", {
            attrs: { appointmentId: _vm.period.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.rescheduleOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4bf1c4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4bf1c4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/timeslot/Period.vue
// module id = null
// module chunks = 